<template>
  <div class="breadcrumbs" v-if="$route.meta.breadcrumbs">
    <div class="app-control">
      <p class="title">{{$route.meta.breadcrumbs[$route.meta.breadcrumbs.length - 1]}}</p>
      <div class="right-region">
        <el-breadcrumb separator="/" v-if="$route.meta.breadcrumbs.length > 1">
          <el-breadcrumb-item v-for="(value, index) in $route.meta.breadcrumbs" :key="index">{{value}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Breadcrumbs'
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .breadcrumbs {
    background-color: @color-1;
    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .app-control {
      height: 100%;
    }
  }
</style>